import React, { lazy, Suspense } from 'react';
import { LoaderFallback } from '../../../shared/LoaderFallback/LoaderFallback';
import { CloseExec } from '../../../ui/CloseButton';
import { TextCustom } from '../../../ui/TextCustom';
import { Title } from '../../../ui/Title';
import { ListFooter } from '../../ListFooter/ListFooter';
import { ListFooterInfo } from '../../ListFooter/ListFooterInfo';
import { ListGrid } from '../../ListGrid/ListGrid';
import { ListHeader } from '../../ListHeader/ListHeader';
import { PanelLayout } from '../../Panel/Panel';
import { Spacing } from '../../Spacing/Spacing';
import useUpdatedStagingData from '../../../features/Dashboard/DashboardStaging/hooks/useUpdatedStagingData';
import { useTranslation } from 'react-i18next';

const Staging = lazy(() => import('../../../features/Dashboard/DashboardStaging/Staging'));
const MemoizedStaging = React.memo(Staging);

export const StagingPanel = () => {
    const { updatedList } = useUpdatedStagingData();
    const { t, i18n } = useTranslation();

    return (
        <PanelLayout>
            <ListGrid>
                {/* <CloseExec distanceInPx={5} func={() => console.log('CLOSE')} /> */}
                <ListHeader>
                    <Spacing marginSpacing={'m'} paddingSpacing={'m'}>
                        <Title text={t('titles.staging')} size={'l'} />
                    </Spacing>
                </ListHeader>
                <Suspense fallback={<LoaderFallback color={'accent-green'} label={'Creating staging'} />}>
                    <MemoizedStaging />
                </Suspense>
                <ListFooter>
                    <ListFooterInfo>
                        <TextCustom color="grey-dark" weight={900}>
                            {updatedList.length}
                        </TextCustom>
                        <TextCustom color="grey-dark">{t('messages.stagingNodesFoundNumber')}</TextCustom>
                    </ListFooterInfo>
                </ListFooter>
            </ListGrid>
        </PanelLayout>
    );
};
